<template>
<div id="footer">
    <span>@Copyright 2019 新华三技术有限公司 </span>
</div>
</template>
<script>
export default {
    name:"footer-copygight",
    date() {
         return {

         }
    }
    
}
</script>
<style lang="less" type="text/less">
  #footer {
                height: 40px;
                line-height: 40px;
                position: absolute;
                bottom: 0;
                width: 100%;
                text-align: center;
               
                color: #333;
                font-family: Arial;
                font-size: 12px;
                letter-spacing: 1px;
            }


</style>




// WEBPACK FOOTER //
// src/components/public/footer.vue